import React from "react"
import { Config } from "final-form"
import { Form as FinalForm, Field, FieldProps, FieldRenderProps, FormProps } from "react-final-form"
import styled from "styled-components"

import { Content, Button } from "src/components/shop"
import { BREAKPOINTS, COLORS } from "src/constants"

interface Props {
  onSubmit: Config["onSubmit"]
  submitLabel: string
}

const Form: React.FC<Props & FormProps> = ({ onSubmit, submitLabel, children, ...props }) => (
  <FinalForm onSubmit={onSubmit} {...props}>
    {({ handleSubmit }) => (
      <Content as="form" onSubmit={handleSubmit}>
        {children}
        <Button type="submit">{submitLabel}</Button>
      </Content>
    )}
  </FinalForm>
)

export default Form

export const Row = styled.div`
  margin: 15px 0;
  input {
    margin: 15px 0;
  }
  @media (min-width: ${BREAKPOINTS.maxWidth + 20}px) {
    display: flex;
    margin-right: -20px;
    input {
      margin: 0 20px 0 0;
    }
  }
`

export const StyledField = styled(Field)`
  display: block;
  border: 1px solid ${COLORS.dark};
  padding: 5px 8px;
  width: ${(props) => (props.component === "input" ? props.width || "390px" : "100%")};
  max-width: 100%;
`

type InputProps = FieldProps<string, FieldRenderProps<string>> & {
  multiline?: boolean
}

export const TextInput: React.FC<InputProps> = ({ multiline, ...props }) => (
  <StyledField component={multiline ? "textarea" : "input"} rows={multiline ? 6 : null} {...props} />
)

export const Infos = styled.div`
  margin-bottom: 40px;
`
export const Label = styled.div`
  font-weight: bold;
  a {
    text-decoration: underline;
  }
`
